/*global chrome*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './_store';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import "react-datepicker/dist/react-datepicker.css";
import ModalProvider from './pages/notifications/sections/ModalProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ModalProvider>
    <Provider store={store} >
        <App />
    </Provider>
    </ModalProvider>
);